/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { componentIterator } from './Iterator.utils';
import { ComponentPropType } from '../../types/component';
var defaultProps = {
  propMap: {},
  itemKey: ''
};
export default function Iterator(_ref) {
  var iterator = _ref.iterator,
    component = _ref.component,
    propMap = _ref.propMap,
    itemKey = _ref.itemKey;
  return /*#__PURE__*/React.createElement(React.Fragment, null, componentIterator({
    iterator: iterator,
    component: component,
    propMap: propMap,
    itemKey: itemKey
  }));
}
Iterator.defaultProps = defaultProps;